import actions from './actions';
import mutations from './mutations';

const emptyLink = {
  id: '',
  version: 0,
  icon: '',
  url: '',
  title: '',
  description: '',
  tags: [],
  organisation: '',
  hidden: false,
  priority: 0,
  created_at: new Date(),
  updated_at: new Date()
};

const state = {
  quickLinks: [],
  link: emptyLink
};

const getters = {
  quickLinks: (stateData) => stateData.quickLinks,
  emptyLink: () => emptyLink
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
